







































import { Watch, Inject, Component, Vue } from 'vue-property-decorator'
import { WinckOffice, WinckScreen } from '@/api/client/winck-proxy'
import { v4 as uuid } from 'uuid'
import { namespace } from 'vuex-class'
const narrowcasting = namespace('narrowcasting')

@Component
export default class CompanySettingsNarrowcastingScreensCreate extends Vue {
    @Inject() readonly navigateToList: () => Promise<void>
    @narrowcasting.State readonly saving!: boolean
    @narrowcasting.State readonly offices!: WinckOffice[]
    @narrowcasting.State readonly screens!: WinckScreen[]
    @narrowcasting.Action readonly createScreen: (screen: WinckScreen) => Promise<void>
    name: string = null
    samsungId: string = null
    officeId: string = null

    async onSave(): Promise<void> {
        await this.createScreen(new WinckScreen(
            uuid(),
            this.name,
            this.samsungId,
            this.officeId,
        ))

        await this.navigateToList()
    }

    async onCancel(): Promise<void> {
        await this.navigateToList()
    }

    @Watch('name')
    @Watch('officeId')
    autoGenerateSamsungIdentifier(): void {
        const office = this.offices.find(v => v.id === this.officeId)
        let i = 0

        this.samsungId = `${office ? office.name : ''} ${this.name || ''}`
            .trim()
            .toLowerCase()
            .replaceAll(' ', '-')

        while (this.screens.some(screen => screen.samsungId === this.samsungId)) {
            i++
            this.samsungId = `${office ? office.name : ''} ${this.name || ''} ${i}`
                .trim()
                .toLowerCase()
                .replaceAll(' ', '-')
        }
    }

    get availableOffices(): Array<{ label: string, value: string }> {
        return this.offices.map(office => {
            return {
                label: office.name,
                value: office.id,
            }
        })
    }
}
